import { useEffect, useRef } from 'react'

import { type FillApplicationState, hasFilesReading } from '@/models/fillApplication'
import { FillApplicationEvent, trackFillApplication } from './fillApplicationAnalytics'

/** `insure_fill_application_opened` once per visit, and `insure_fill_application_parse_finished` when reading stops. */
export function useFillApplicationTracking(orgId: string, state: FillApplicationState | undefined) {
  const opened = useRef(false)
  const readingSince = useRef<number | null>(null)
  const reading = hasFilesReading(state)
  const counts = state?.batch?.counts

  useEffect(() => {
    if (!state || opened.current) return
    opened.current = true
    trackFillApplication(FillApplicationEvent.OPENED, { org_id: orgId, opening_state: state.openingState })
  }, [orgId, state])

  useEffect(() => {
    if (reading) {
      readingSince.current ??= Date.now()
      return
    }
    if (readingSince.current === null) return
    trackFillApplication(FillApplicationEvent.PARSE_FINISHED, {
      org_id: orgId,
      duration_seconds: Math.round((Date.now() - readingSince.current) / 1000),
      counts: counts ?? {},
    })
    readingSince.current = null
  }, [reading, orgId, counts])
}
